<template>
    <div>
        <div class="c-profile-rt-input">
          <!-- <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
          <!-- <div style="margin: 15px 0;"></div> -->
          <el-checkbox-group v-model="checkedIndustrycategories" @change="handleIndustrycategoryChange">
            <el-checkbox v-for="category in industrycategories.service.list" :label="category" :key="category">{{category}}</el-checkbox>
          </el-checkbox-group>
      </div>
    </div>
</template>

<script>
import { Checkbox, CheckboxGroup } from 'element-ui';

export default {
    name: 'FinacialService',
    components: {
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    props: {
        selectedOptions: {
            type: String
        }
    },
    watch: {
        selectedOptions(n, o) {
            this.handleSelectedOptionsProps(n);
        }
    },
    data() {
        return {
            industrycategories: {
            
                service: {
                    name: '智慧专区',
                    list: ['银行服务','风险投资','投资基金','融资担保','债券股票','民间借贷']
                },
            },
            checkAll: false,
            checkedIndustrycategories: [],
        }
    },
    mounted() {
        this.emitData();
    },
    methods: {
        handleSelectedOptionsProps(v) {
            if (v) {
                const options = v.split(';');
                this.checkedIndustrycategories = this.industrycategories.service.list.find((item) => {
                    return options.includes(item);
                }) || [];
                this.handleCheckAll();
            }
        },
        handleCheckAllChange(val) {
            this.checkedIndustrycategories = val ? this.industrycategories.service.list: [];
            this.checkAll1 = val;
        },
        handleCheckAll() {
            const checked = this.checkedIndustrycategories.length;
            const total = this.industrycategories.service.list.length;
            this.checkAll = checked === total;
            this.emitData();
        },
        handleIndustrycategoryChange(value) {
            this.checkAll1 = value.length === this.industrycategories.service.list.length;
            this.handleCheckAll();
        },
        getCheckedCategories() {
            return this.checkedIndustrycategories;
        },
        emitData() {
            this.$emit('dataChange', {
                checked: this.getCheckedCategories()
            });
        }
    }
}
</script>

<style scoped>
</style>